export var variantTypeForSpotifyType = {
    Show: "default",
    Track: "compact",
    Playlist: "default",
    Episode: "default",
    Album: "default",
};
